import { cmsAxiosInstance } from '../configuration/axiosConfig';
import { ClientResponse } from '../model/ClientResponse';
import AktualitaListPage from '../model/AktualitaListPage';
import Aktualita from '../model/Aktualita';
import { PER_PAGE_VALUE } from '../page/AktualitaListPage/hook/useAktualitaList';
import { getLastPage } from '../function/getPaginationTotalLabel';

const mapToAktualitaListPage = (responseItem): AktualitaListPage => (
  {
    total: responseItem.total,
    offset: responseItem.offset,
    limit: responseItem.limit,
    results: responseItem.results?.map(aktualita => mapAktualita(aktualita)),
  }
);

const mapAktualita = (aktualita): Aktualita => ({
  id: aktualita['@name'],
  text: aktualita.text,
  autor: aktualita.autor,
  title: aktualita.title,
  img: aktualita.img,
  vypublikovane: aktualita['mgnl:created'],
});

export const getAktualitaList = async (limit, page):
  Promise<ClientResponse<AktualitaListPage>> => {
  let offset = (page - 1) * limit;
  let response = await cmsAxiosInstance.get(
    `/aktuality?orderBy=mgnl:created%20desc&limit=${limit}&offset=${offset}`,
  );

  const lastPage = getLastPage(PER_PAGE_VALUE, response.data.total);
  if (page > lastPage) { // when page is changed in url then max page is the last page
    offset = (lastPage - 1) * limit;
    response = await cmsAxiosInstance.get(
      `/aktuality?orderBy=mgnl:created%20desc&limit=${limit}&offset=${offset}`,
    );
  }

  return {
    data: mapToAktualitaListPage(response.data),
    responseCode: response.status,
  };
};
